module.exports = __webpack_public_path__ + "static/img/brees-2006-slide-1.9d8ea0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2006-slide-1.jpg
// module id = JK6p
// module chunks = 1